import React from 'react'
import Zoom from 'react-reveal/Zoom';
function About_discraption() {
  return (
    <>
    <div className=''>
      {/* -------------------------------Mobile view--------------------------------- */}
      <Zoom>
      <div className='container d-sm-block d-md-none'>
        <div className='text-center mt-3 mobile_About_Discraption_text'>
          <h2 className='display-4 text-center'>Who We Are</h2>
          <p className='' >At InternsElite, we help students unlock their full potential by providing the essential knowledge, advanced tools, and practical resources needed to make smart career choices. Our programs combine innovative technology, including AI-driven learning tools, with hands-on guidance to enhance your skills across technical and non-technical domains. Whether you are exploring internships or aiming to build industry-ready expertise, InternsElite ensures every step of your career journey is supported with personalized learning and professional mentorship.</p>
          <h3 className='display-6 border-bottom pb-4 pt-2 Review_not_copy'>At InternsElite, live the real world and rule the world. </h3>
        </div>
      </div>
      </Zoom>


      {/* -------------------------------Dasktop view--------------------------------- */}
      <Zoom>
      <div className='container d-none d-md-block pt-4'>
        <div className='row'>
            <div className='container px-5'>
            <div className='text-center About_Discraption_text'>
                <h2 className='display-4'>Who We Are</h2>
                <p>At InternsElite, we help students unlock their full potential by providing the essential knowledge, advanced tools, and practical resources needed to make smart career choices. Our programs combine innovative technology, including AI-driven learning tools, with hands-on guidance to enhance your skills across technical and non-technical domains. Whether you are exploring internships or aiming to build industry-ready expertise, InternsElite ensures every step of your career journey is supported with personalized learning and professional mentorship.</p>
                <h3 className='display-6 Review_not_copy'>At InternsElite, live the real world and rule the world.</h3>
            </div>
            </div>
        </div>
      </div>
      </Zoom>
    </div>
    </>
  )
}

export default About_discraption
